import { useState, useEffect } from 'react';
import '../styles/AdminContacto.css';

const CAMPOS = [
  { key: 'whatsapp',          label: 'WhatsApp',          placeholder: '5491112345678',   hint: 'Solo números con código de país' },
  { key: 'whatsapp_mensaje',  label: 'Mensaje predefinido', placeholder: 'Hola! Consulto por...' },
  { key: 'direccion',         label: 'Dirección',          placeholder: 'Av. Corrientes 1234, CABA' },
  { key: 'horarios',          label: 'Horarios',           placeholder: 'Lun–Vie 9–18 h · Sáb 10–14 h' },
  { key: 'email_contacto',    label: 'Email de contacto',  placeholder: 'tienda@ejemplo.com', type: 'email' },
  { key: 'instagram',         label: 'Instagram (URL)',    placeholder: 'https://instagram.com/tu_tienda' },
  { key: 'facebook',          label: 'Facebook (URL)',     placeholder: 'https://facebook.com/tu_tienda' },
];

export default function AdminContacto({ isOpen, onClose }) {
  const [tab, setTab] = useState('config'); // 'config' | 'mensajes'
  const [config, setConfig] = useState({});
  const [guardando, setGuardando] = useState(false);
  const [guardadoOk, setGuardadoOk] = useState(false);
  const [errorGuardar, setErrorGuardar] = useState('');

  const [mensajes, setMensajes] = useState([]);
  const [cargandoMsj, setCargandoMsj] = useState(false);
  const [mensajeAbierto, setMensajeAbierto] = useState(null);

  // Cargar config al abrir
  useEffect(() => {
    if (!isOpen) return;
    fetch('/api/config')
      .then(r => r.json())
      .then(data => setConfig(data))
      .catch(() => {});
  }, [isOpen]);

  // Cargar mensajes al cambiar a esa pestaña
  useEffect(() => {
    if (!isOpen || tab !== 'mensajes') return;
    setCargandoMsj(true);
    fetch('/api/contacto/mensajes')
      .then(r => r.json())
      .then(data => setMensajes(data))
      .catch(() => setMensajes([]))
      .finally(() => setCargandoMsj(false));
  }, [isOpen, tab]);

  const handleChange = (e) => {
    setConfig(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setGuardadoOk(false);
    setErrorGuardar('');
  };

  const guardar = async () => {
    setGuardando(true);
    setErrorGuardar('');
    try {
      const res = await fetch('/api/config', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al guardar');
      setGuardadoOk(true);
      setTimeout(() => setGuardadoOk(false), 3000);
    } catch (err) {
      setErrorGuardar(err.message);
    } finally {
      setGuardando(false);
    }
  };

  const marcarLeido = async (id) => {
    await fetch(`/api/contacto/mensajes/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ leido: true }),
    });
    setMensajes(prev => prev.map(m => m._id === id ? { ...m, leido: true } : m));
  };

  const abrirMensaje = (msj) => {
    setMensajeAbierto(msj);
    if (!msj.leido) marcarLeido(msj._id);
  };

  const noLeidos = mensajes.filter(m => !m.leido).length;

  if (!isOpen) return null;

  return (
    <div className="ac-overlay" onClick={onClose}>
      <div className="ac-panel" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="ac-header">
          <div>
            <h2 className="ac-titulo">Contacto</h2>
            <p className="ac-subtitulo">Configuración y mensajes recibidos</p>
          </div>
          <button className="ac-close" onClick={onClose}>✕</button>
        </div>

        {/* Tabs */}
        <div className="ac-tabs">
          <button
            className={`ac-tab ${tab === 'config' ? 'activo' : ''}`}
            onClick={() => setTab('config')}
          >
            ⚙ Configuración
          </button>
          <button
            className={`ac-tab ${tab === 'mensajes' ? 'activo' : ''}`}
            onClick={() => setTab('mensajes')}
          >
            ✉ Mensajes
            {noLeidos > 0 && <span className="ac-badge">{noLeidos}</span>}
          </button>
        </div>

        {/* Body */}
        <div className="ac-body">

          {/* ── Config ── */}
          {tab === 'config' && (
            <div className="ac-config-form">
              {CAMPOS.map(campo => (
                <div key={campo.key} className="ac-field">
                  <label>{campo.label}</label>
                  {campo.hint && <span className="ac-field-hint">{campo.hint}</span>}
                  <input
                    type={campo.type || 'text'}
                    name={campo.key}
                    value={config[campo.key] || ''}
                    onChange={handleChange}
                    placeholder={campo.placeholder}
                    disabled={guardando}
                  />
                </div>
              ))}

              <div className="ac-config-footer">
                {errorGuardar && <p className="ac-error">⚠ {errorGuardar}</p>}
                {guardadoOk && <p className="ac-ok">✓ Guardado correctamente</p>}
                <button
                  className="ac-btn-guardar"
                  onClick={guardar}
                  disabled={guardando}
                >
                  {guardando ? 'Guardando…' : 'Guardar cambios'}
                </button>
              </div>
            </div>
          )}

          {/* ── Mensajes ── */}
          {tab === 'mensajes' && (
            <div className="ac-mensajes">
              {cargandoMsj ? (
                <p className="ac-cargando">Cargando mensajes…</p>
              ) : mensajes.length === 0 ? (
                <p className="ac-vacio">No hay mensajes recibidos.</p>
              ) : mensajeAbierto ? (
                <div className="ac-msj-detalle">
                  <button className="ac-back" onClick={() => setMensajeAbierto(null)}>
                    ← Volver
                  </button>
                  <div className="ac-msj-detalle-header">
                    <span className="ac-msj-nombre">{mensajeAbierto.nombre}</span>
                    <a href={`mailto:${mensajeAbierto.email}`} className="ac-msj-email">
                      {mensajeAbierto.email}
                    </a>
                    <span className="ac-msj-fecha">{mensajeAbierto.fecha}</span>
                  </div>
                  <div className="ac-msj-cuerpo">{mensajeAbierto.mensaje}</div>
                  <a
                    href={`mailto:${mensajeAbierto.email}?subject=Re: tu consulta`}
                    className="ac-btn-responder"
                  >
                    ✉ Responder por email
                  </a>
                </div>
              ) : (
                <ul className="ac-msj-lista">
                  {mensajes.map(msj => (
                    <li
                      key={msj._id}
                      className={`ac-msj-item ${!msj.leido ? 'no-leido' : ''}`}
                      onClick={() => abrirMensaje(msj)}
                    >
                      <div className="ac-msj-item-top">
                        <span className="ac-msj-item-nombre">{msj.nombre}</span>
                        <span className="ac-msj-item-fecha">{msj.fecha}</span>
                      </div>
                      <span className="ac-msj-item-email">{msj.email}</span>
                      <p className="ac-msj-item-preview">{msj.mensaje}</p>
                      {!msj.leido && <span className="ac-msj-dot" />}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
